//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cercle-empty.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cercle-tick.svg';
export default {
  name: 'MdmRadio',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,

      default() {
        return [];
      }

    },
    showError: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      selected: null,
      checked: false
    };
  },

  created() {
    this.selected = this.value;
  },

  methods: {
    select() {
      this.$emit('input', this.selected);
    }

  }
};